import React, { useState, useRef, useEffect } from 'react';
import { Tooltip } from 'antd';

const useIsTextOverflowing = () => {
  const ref = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const element = ref.current;
      if (element) {
        const lineHeight = parseInt(getComputedStyle(element).lineHeight);
        const maxHeight = lineHeight * 2;
        setIsOverflowing(element.scrollHeight > maxHeight);
      }
    };

    checkOverflow();

    const observer = new ResizeObserver(checkOverflow);
    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return [ref, isOverflowing];
};


const ConditionalTooltip = ({ title, placement = "topLeft", className, children }) => {
  const [labelRef, isOverflowing] = useIsTextOverflowing();

  return (
    <Tooltip 
      title={isOverflowing ? title : null} 
      placement={placement}
    >
      <label ref={labelRef} className={className}>
        {children || title}
      </label>
    </Tooltip>
  );
};

export default function LabelWithToolTips({ title, className }) {
  return (
    <ConditionalTooltip placement="topLeft" title={title}>
      <label className={className}>{title}</label>
    </ConditionalTooltip>
  );
}
